import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import { useLocation } from "react-router-dom";
import { LoadingButton } from '@mui/lab';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { Link } from 'react-router-dom';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { saveAs } from 'file-saver';
import { OpenSwal } from '../../Utils';
import { url_get_default_invoice_blob } from '../../RoutesMap';
import { apiWithAuth } from '../../Services/Axios/axios';



function SplashScreenCustom() {

    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;
    const navigate = useNavigate();

    const uselocation = useLocation();
    const [location, SetLocation] = useState((uselocation) ? uselocation : {});
    const [LoadingButtonStatus, LoadingButtonStatusSet] = useState(false);

    const DownloadDefaultInvoice = () => {
        LoadingButtonStatusSet(true);
        let payload = {
            assign_ids: location.state.data
        };
        apiWithAuth.post(url_get_default_invoice_blob, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                LoadingButtonStatusSet(false);
                saveAs(response.data.file_blob, response.data.file_name);
            } else if (response.data.status === false && response.data.message === "Token Expired") {
                LoadingButtonStatusSet(false);
                OpenSwal('Token_error', navigate);
            } else {
                LoadingButtonStatusSet(false);
                OpenSwal('Axios_error', response.data.message);
            }
        }).catch(response => {
            LoadingButtonStatusSet(false);
            OpenSwal('Axios_error', response.message);
        });
    }




    return (
        <Box>
            <Container component="main" maxWidth="xs"  >
                <Box sx={{ mt: 20 }}  >
                    {location.state && <Box>
                        <Typography variant="h4" align="center" color={appThemeColor}>{location.state.header}</Typography>
                    </Box>}
                    {location.state && <Box mt={2}>
                        <Typography variant="body1" align="center" >{location.state.body}</Typography>
                    </Box>}
                    {location.state && location.state.subtitle && <Box mt={2}>
                        <Typography variant="body2" align="center" >{location.state.subtitle}</Typography>
                    </Box>}
                    {location.state && location.state.status === "default_raise_invoice" && <Box mt={2} >
                        <Box display='flex' justifyContent='center' >
                            <Button LinkComponent={Link} to={location.state.path} variant='contained' startIcon={<ArrowBackOutlinedIcon />} color={appThemeSecondaryColor} sx={{ backgroundColor: appThemeColor, textTransform: 'none' }} size='small'>Back to raise invoice</Button>
                            <LoadingButton variant='contained' startIcon={<CloudDownloadOutlinedIcon />} loadingPosition='start' loading={LoadingButtonStatus} sx={{ backgroundColor: '#89B601 ', textTransform: 'none', ml: 2, '&:hover': { backgroundColor: '#719700' } }} size='small' onClick={DownloadDefaultInvoice} >Download Invoice Copy</LoadingButton>
                        </Box>

                    </Box>}
                </Box>
            </Container>
        </Box>
    )
}

export default SplashScreenCustom